import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, PUT, POST } from "../../../../../services/index";

export const useFetchNotificationSetting = () => {
  return useQuery(["notificationSettingAdmin"], async () => {
    const { result } = await GET("/api/v1/notificationSetting");
    return result;
  });
};

export const useSaveNotificationSetting = () => {
  return useMutation({
    mutationFn: async (payload) => await PUT("/api/v1/notificationSetting", payload),
  });
};

export const useUploadNotificationSound = () => {
  return useMutation({
    mutationFn: async (payload) => await POST("/api/v1/notificationSetting/sound", payload),
  });
};
